import { menuItemTableFactoryCore } from './chunk-OMVDHYS5.mjs';
import { menuComboCardFactoryCore } from './chunk-KUMI3MOI.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import isEqual from 'lodash/isEqual';
import mapValues from 'lodash/mapValues';
import omit from 'lodash/omit';

var menuCombosTableFactoryCore = (combos, categories, subcategories, menuTypes, taxes) => {
  return Object.values(combos).map((combo) => {
    const comboObject = { [combo.comboId]: combo };
    const itemGroupIds = [];
    const itemGroups = [];
    let areItemGroupsDifferent = false;
    const comboObjectForTable = mapValues(comboObject, (comboToMap) => __spreadProps(__spreadValues({}, comboToMap), {
      itemId: comboToMap.comboId,
      menuTypeVersions: mapValues(
        comboToMap.menuTypeVersions,
        (menuTypeVersion) => __spreadProps(__spreadValues({}, menuTypeVersion), {
          itemPrice: menuTypeVersion.comboBasePrice,
          modifierGroups: {},
          prepStationIds: []
        })
      )
    }));
    const comboTableRow = menuItemTableFactoryCore(
      comboObjectForTable,
      categories,
      subcategories,
      menuTypes,
      taxes,
      {},
      {},
      {}
    )[0];
    const comboCoreCard = menuComboCardFactoryCore(
      comboObject,
      categories,
      subcategories,
      menuTypes
    )[0];
    const transformToCombo = (itemTableRow) => {
      return __spreadProps(__spreadValues({}, comboCoreCard), {
        id: itemTableRow.id,
        title: itemTableRow.title,
        menuTypeId: itemTableRow.menuTypeId,
        categoryId: itemTableRow.categoryId,
        subcategoryId: itemTableRow.subcategoryId,
        price: itemTableRow.price,
        taxes: itemTableRow.taxes,
        categoriesSubcategories: itemTableRow.categoriesSubcategories,
        status: itemTableRow.status,
        itemGroups: null,
        children: []
      });
    };
    return __spreadProps(__spreadValues({}, transformToCombo(comboTableRow)), {
      children: comboTableRow.children.map((child) => {
        const menuTypeItemGroups = Object.values(
          combo.menuTypeVersions[child.menuTypeId[0]].itemGroups
        );
        const menuTypeItemGroupIds = menuTypeItemGroups.map(
          (itemGroup) => itemGroup.itemGroupId
        );
        const menuTypeItemGroupsString = menuTypeItemGroups.map(
          (itemGroup) => itemGroup.name
        );
        menuTypeItemGroupIds.forEach((itemGroupId, index) => {
          if (!itemGroupIds.includes(itemGroupId)) {
            itemGroupIds.push(itemGroupId);
            itemGroups.push(menuTypeItemGroupsString[index]);
          }
        });
        if (!areItemGroupsDifferent && !isEqual(itemGroupIds, menuTypeItemGroupIds)) {
          areItemGroupsDifferent = true;
        }
        return __spreadProps(__spreadValues({}, omit(transformToCombo(child), "children")), {
          itemGroups: menuTypeItemGroupsString.join(", ") || void 0
        });
      }),
      itemGroups: areItemGroupsDifferent ? null : itemGroups.join(", ") || void 0
    });
  });
};

export { menuCombosTableFactoryCore };
